export const flattenArray = <T>(list: T[], key: keyof T & string): T[] => {
  let children: T[] = []

  const flatten = list.map((item: T) => {
    const childItems = item[key] as unknown as T[]
    if (Array.isArray(childItems)) {
      children = [...children, ...childItems]
    }
    return item
  })

  return flatten.concat(
    children.length ? flattenArray(children, key) : children
  )
}
